import styled from 'styled-components'

const SubHeader = styled.div`
  margin-bottom: 20px;
`

const SubPageHeader = ({ children }) => <SubHeader>{children}</SubHeader>

export default SubPageHeader
